var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.component,{tag:"component",attrs:{"mode":"print","view":_vm.current_view},on:{"update:view":function($event){_vm.current_view=$event}},model:{value:(_vm.itemRevision),callback:function ($$v) {_vm.itemRevision=$$v},expression:"itemRevision"}})
}
var staticRenderFns = []

export { render, staticRenderFns }